import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../types/rootstate'

import { strings } from '../lib/localization'

import '../sass/brandingform.scss'
import '../sass/answers/chatbutton.scss'
import escapeHandler from '../lib/escape-handler'
import imboxLogo from '../fonts/icon-imboxlogo.svg'

export const BrandingIcon = ({ onClick }: { onClick: () => void }) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }
  return (
    <div className='branding'>
      <div
        onClick={onClick}
        role='button'
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {strings['brandingText']} <img src={imboxLogo} alt='ImBox' />
      </div>
    </div>
  )
}

interface StateProps {
  userId: number
  currentUrl: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DispatchProps {}

interface OwnProps {
  type: 'answers' | 'online' | 'forms'
  goBack: () => void
}

type BrandingProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    userId: state.widget.userId,
    currentUrl: encodeURIComponent(state.widget.host.url)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {}
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface BrandingState {}

class BrandingComponent extends React.Component<BrandingProps, BrandingState> {
  goBack = React.createRef<HTMLDivElement>()

  componentDidMount() {
    escapeHandler.registerEscapeListener(this.handleEscape)
    this.goBack.current.focus()
  }

  componentWillUnmount() {
    escapeHandler.removeEscapeListener(this.handleEscape)
  }

  handleEscape = () => {
    this.props.goBack()
  }

  handleBackKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.goBack()
    }
  }

  render() {
    const brandingContent = {
      __html:
        this.props.type === 'online'
          ? strings['brandingPageOnline']
          : this.props.type === 'answers'
          ? strings['brandingPageAnswers']
          : strings['brandingPageForms']
    }
    const backButtonText =
      this.props.type === 'online'
        ? strings['brandingPageOnlineBackButton']
        : this.props.type === 'answers'
        ? strings['brandingPageAnswersBackButton']
        : strings['brandingPageFormsBackButton']

    return (
      <div
        className='brandingform'
        role='dialog'
        aria-describedby='imboxBranding'
      >
        <div
          className='brandingcontent'
          dangerouslySetInnerHTML={brandingContent}
          id='imboxBranding'
        />
        <a
          className='input-line chatbutton accentSecondaryButton'
          target='_blank'
          rel='noopener noreferrer'
          href={
            strings['brandingLink'] +
            '?utm_source=' +
            this.props.currentUrl +
            '&utm_campaign=' +
            this.props.userId +
            '&utm_medium=widget-v2-' +
            this.props.type
          }
        >
          <label>{strings['brandingPageVisitButton']}</label>
        </a>

        <div
          ref={this.goBack}
          className='input-line chatbutton backbutton'
          // eslint-disable-next-line react/jsx-handler-names
          onClick={this.props.goBack}
          role='button'
          tabIndex={0}
          onKeyDown={this.handleBackKeyDown}
        >
          <label>{backButtonText}</label>
        </div>
      </div>
    )
  }
}

const Branding = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(BrandingComponent)

export { Branding }
